// TourHost — the single mount point App.jsx renders. Picks the prompt or the
// overlay off the tour's status so App.jsx never has to know either exists.
import React from 'react';
import { useTour } from '../../contexts/TourContext';
import TourPrompt from './TourPrompt';
import TourOverlay from './TourOverlay';

function TourHost() {
  const { status } = useTour();
  if (status === 'prompt') return <TourPrompt />;
  if (status === 'running') return <TourOverlay />;
  return null;
}

export default TourHost;
